import adminApi from "services/admin-api";

export const currentUserQueryKey = ["current-user"] as const;

type CurrentUserQueryOverrides = Record<string, unknown>;

export const buildCurrentUserQueryOptions = (overrides: CurrentUserQueryOverrides = {}) => ({
  queryKey: currentUserQueryKey,
  queryFn: adminApi.currentUser,
  staleTime: 60_000,
  ...overrides,
});
